window.mdc.autoInit();
window.$ = window.jQuery = require('jquery');
require('@fancyapps/fancybox');
import "webcomponentsjs/micro";
window.Dropzone = require('dropzone/dist/dropzone.js');

$( '[data-fancybox="image"]' ).fancybox({
  hash: false,
  buttons : [
    'slideShow',
    'fullscreen',
    'thumbs',
    'download',
    'zoom',
    'close'
  ]
});

if(document.querySelector('#fp-image-scroller')){
  mdc.tabs.MDCTabBarScroller.attachTo(document.querySelector('#fp-image-scroller'));
}

$('#fp-upload-button').click(function(event) {
  var dialog = new mdc.dialog.MDCDialog(document.querySelector('#fp-upload'));
  event.preventDefault();
  dialog.show();

});
if($('#fp-scrollable-tab-bar').find('.current').length===0) {
  $('.mdc-tab-bar__indicator').hide();
}
$('.fp-upload-done').click(function() {
  console.log("fp-upload-button hier");

  console.log("hier");
  location.href='/bilder/unsortiert';
});
$('input[name=ajax]').val(1);
$('.fp-guest-form button[type=submit]').hide();
$('.fp-guest-form').change(function() {
  var accepted = $(this).find('input[name=accepted]:checked').val();
console.log(accepted);
if(accepted!=0&&accepted!=1) {
console.log("keineantwort");
$(this).find('input[name=accepted][value=1]').prop('checked', true);
console.log($(this).find('input[name=accepted]').val(1));
$(this).submit(function(e) {
      e.preventDefault();
      var guestdata = $(this).serializeArray();

      console.log(guestdata);
      $.ajax({
        method: "PATCH",
        url: $(this).attr('action'),
        data: guestdata
      })
      .done(function( msg ) {
        var MDCSnackbar = global.mdc.snackbar.MDCSnackbar;
        var snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
        console.log(snackbar);
        var show = function(sb) {
          var data =  {
            message: msg
          };
          sb.show(data);
        };
        show(snackbar);
      });
    });

$(this).submit();
    $(this).unbind("submit");
}
  if(accepted) {
    $(this).submit(function(e) {
      e.preventDefault();
      var guestdata = $(this).serializeArray();

      console.log(guestdata);
      $.ajax({
        method: "PATCH",
        url: $(this).attr('action'),
        data: guestdata
      })
      .done(function( msg ) {
        var MDCSnackbar = global.mdc.snackbar.MDCSnackbar;
        var snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
        console.log(snackbar);
        var show = function(sb) {
          var data =  {
            message: msg
          };
          sb.show(data);
        };
        show(snackbar);
      });
    });
    $(this).submit();
    $(this).unbind("submit");
  }
});
$('.fp-present-form').change(function() {
  $(this).submit(function(e) {
    e.preventDefault();
    var presentdata = $(this).serializeArray();

    console.log(presentdata);
    $.ajax({
      method: "PATCH",
      url: $(this).attr('action'),
      data: presentdata
    })
    .done(function( msg ) {
      var MDCSnackbar = global.mdc.snackbar.MDCSnackbar;
      var snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
      console.log(snackbar);
      var show = function(sb) {
        var data =  {
          message: msg
        };
        sb.show(data);
      };
      show(snackbar);
    });
  });
  $(this).submit();
  $(this).unbind("submit");
});
$('.fp-dark-form').change(function() {
  $(this).submit();
  $(this).unbind("submit");
});
Dropzone.options.fpimagedropzone = {
  parallelUploads: 3,
  acceptedFiles: 'image/*',
  addRemoveLinks: true,
  dictDefaultMessage: 'Dateien hierher ziehen oder per Klick auswählen',
  dictRemoveFile: 'Datei löschen',
  dictCancelUpload: 'Upload abbrechen',
  dictCancelUploadConfirmation: 'Bist du dir sicher, dass du den Upload abbrechen willst?',

  init:function() {
    this.on("removedfile", function(file) {
      console.log($('[name=_token]').val());
      console.log("remove");
      console.log(file);
      $.ajax({
        type: 'POST',
        url: '/images/upload/delete',
        data: {id: file.fp_id, _token: $('[name=_token]').val()},
        dataType: 'html',
        success: function(data){
          var rep = JSON.parse(data);
          if(rep.code == 200)
          {
          }

        }
      });
    });
    this.on("success", function(file, responseText) {
      console.log(responseText);
      file['fp_id']=responseText;
      console.log(file);
    });
    this.on("queuecomplete", function(file) {
      $('.fp-upload-done').removeAttr('disabled');
    });
  }
};
if(document.querySelector('.fp-video')) {
  var BackTube = require('back-tube');
  new BackTube(document.querySelector('body'), {
    videoId: 'HqT9vSQvSos',
    playsinline: true,
    cover: 'rgba(255,255,255,0.05)',
  });
  $('.backtube-container').css('opacity', 0);
  console.log("hier");
  console.log(BackTube.apiReady);
  console.log("hier2");
  setTimeout(function(){
    $('.backtube-container').css('opacity', 1); }, 2500);
  }



// WEBPACK FOOTER //
// ./resources/assets/js/app.js